import { CallIcon, ErrorFillIcon, Text } from '@thefarmersfront/kitchen';

import { SMART_SEARCH_PHONE_NUMBER } from '~/constants';

import styles from './SmartSearchError.module.scss';

type SmartSearchErrorProps = {
  errorMessage?: string;
};

const SmartSearchError = ({ errorMessage }: SmartSearchErrorProps) => {
  return (
    <div className={styles['error']}>
      <div className={styles['message']}>
        <ErrorFillIcon size={64} color="gray400" />
        <div className={styles['text']}>
          <div className={styles['text-content']}>
            <Text size="xlarge" weight="semi-bold">
              {errorMessage || '정확한 답변이 어렵습니다.'}
            </Text>
            <Text size="large" color="tertiary">
              문제가 해결되지 않았다면 연락주세요.
            </Text>
          </div>
          <div className={styles['phone']}>
            <CallIcon size={24} color="gray600" />
            <Text size="xlarge" weight="semi-bold" color="tertiary">
              {SMART_SEARCH_PHONE_NUMBER}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartSearchError;
